/* istanbul ignore file */
export class SurveySeededResponse {
    public created_at: number;
    public answerKey: string;
    public seeded = true;

    constructor(public id: string, public value: any) {
        if (value === 'true') {
            this.value = true;
        } else if (value === 'false') {
            this.value = false;
        } else {
            this.answerKey = value;
        }

        this.created_at = new Date().getTime();
    }
}
